import { UserDetails } from '@app/admin/models/user-details';
import { UntypedFormBuilder, UntypedFormGroup, Validators, UntypedFormArray } from '@angular/forms';

export const buildUserForm = (formBuilder: UntypedFormBuilder, user: UserDetails): UntypedFormGroup => {
  const form = formBuilder.group({
    username: [{ value: '', disabled: true }, Validators.required],
    fullName: ['', Validators.required],
    sapId: ['', Validators.required],
    sitePermissions: formBuilder.array([]),
    projectPermissions: formBuilder.array([]),
  });

  form.patchValue({
    username: user.username,
    fullName: (user as any).name ?? user.fullName,
    sapId: user.sapId,
  });

  user.permissions.sites.forEach((s) => {
    const sitePermissionGroup = formBuilder.group({
      name: [{ value: '', disabled: true }, Validators.required],
      roles: formBuilder.group({
        FOREMAN: [s.roles.FOREMAN],
        OPERATOR: [s.roles.OPERATOR],
      }),
    });

    sitePermissionGroup.patchValue(s);

    (form.get('sitePermissions') as UntypedFormArray).push(sitePermissionGroup);
  });

  user.permissions.projects.forEach((p) => {
    const projectPermissionGroup = formBuilder.group({
      name: [{ value: '', disabled: true }, Validators.required],
    });
    projectPermissionGroup.patchValue(p);
    (form.get('projectPermissions') as UntypedFormArray).push(projectPermissionGroup);
  });

  return form;
};
